import {
  AlarmTwoTone,
  AudioFileTwoTone,
  BookOnlineTwoTone,
  BookSharp,
  BookTwoTone,
  GroupTwoTone,
  HomeTwoTone,
  MessageTwoTone,
  MoneyTwoTone,
  Settings
} from '@mui/icons-material';
import { ReactNode } from 'react';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
}

const adminMenuItems: MenuItems[] = [
  {
    heading: '',
    items: [
      {
        name: 'Dashboard',
        link: '/admin/dashboard',
        icon: HomeTwoTone
      },
      {
        name: 'Campagnes',
        link: '/admin/campagne',
        icon: AlarmTwoTone
      },
      {
        name: 'Utilisateurs',
        link: '/admin/utilisateurs',
        icon: GroupTwoTone
      },
      {
        name: 'Salaatu bés bi',
        link: '/admin/salatou',
        icon: BookOnlineTwoTone
      },
      {
        name: 'Khassida',
        link: '/admin/khassida',
        icon: BookOnlineTwoTone
      },
      {
        name: 'Al Quran',
        link: '/admin/al-quran',
        icon: BookTwoTone
      },
      {
        name: 'Azkaar',
        link: '/admin/azkaar',
        icon: BookSharp
      },
      {
        name: 'Cotisations & Dépenses',
        link: '/admin/cotisations',
        icon: MoneyTwoTone
      },
      {
        name: 'Playlist',
        link: '/admin/playlist',
        icon: AudioFileTwoTone
      },
      {
        name: 'Settings',
        link: '/admin/settings',
        icon: Settings
      },
      {
        name: 'Contacts',
        link: '/admin/contacts',
        icon: MessageTwoTone
      },
      {
        name: 'Administrators',
        link: '/admin/Administrators',
        icon: GroupTwoTone
      }
    ]
  }
];

export function useMenuItems() {
  return adminMenuItems;
}

export function useAllMenuItems() {
  const items = useMenuItems();
  return items.reduce(
    (acc: MenuItems['items'], cur) => [...acc, ...cur.items],
    []
  );
}
